

















































/* eslint-disable no-param-reassign */
/* eslint-disable no-use-before-define */
/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import SingleLayerElementSimplified from '@/components/layers/SingleLayerElementSimplified.vue';
import LayerGroupConfig from '@/models/map-context/LayerGroupConfig';
import Plugin from '@/models/plugin/Plugin';
import Component from 'vue-class-component';
import BaseComponent from '../BaseComponent';

@Component({
  name: 'GroupLayerSimplified',
  props: {
    layer: LayerGroupConfig,
    plugin: {},
  },
  components: {
    SingleLayerElementSimplified,
    GroupLayerSimplified,
  },
})
export default class GroupLayerSimplified extends BaseComponent {
  layer!: LayerGroupConfig;

  plugin!:Plugin;

  showConfigBtn = true;

  collapsed = true;

  mounted() {
    
  }

  get childs() {
    return this.layer.childs;
  }

  get visible(): boolean {
    return this.layer.visible;
  }

  set visible(visibility: boolean) {
    this.layer.setVisible(!this.layer.visible);
  }
  

  isFirstElementInTree() {
    return (
      this.contextService.getCurrentContext().getLayers()[0] === this.layer
      || (this.layer.parent !== undefined
        && this.layer.parent.childs[0] === this.layer)
    );
  }

  isEmptyGroup() {
    return this.layer.childs.length === 0;
  }







  infoGroup() {
    this.contextService.setCurrentAction('infoGroup', this.layer);
  }

  deleteGroup(): void {
    this.getMapService().removeGroupFromList(this.layer);
  }

  onChange(): void {
    this.layer.setVisible(!this.layer.visible);
  }

  toggle(): void {
    this.collapsed = !this.collapsed;
  }
}
